export const preventDoubleClickFunction = (e, handleSomething) => {
    if (!e.detail || e.detail === 1) {
        if (typeof handleSomething === 'function') handleSomething();
    }
}
